<template>
  <div class="ma-0 pa-0">
    <v-btn v-show="expandable" @click="showForm = !showForm" text small>
      <v-icon left small>search</v-icon>
      {{showForm? "close": "open"}} filters {{(!showForm && filtersPresent)? " (FILTERED)":""}}
    </v-btn>
    <v-expand-transition>
      <div v-show="showForm || !expandable">
        <div class="ma-0 pl-5 pr-5 pa-2" style="background:white;">
          <v-form @submit.prevent="onChange">
            <v-row>
              <v-col v-if="create" class="shrink">
                <v-btn color="primary" @click="$emit('create')">
                  <v-icon left>add</v-icon>
                  create {{modelName}}
                </v-btn>
              </v-col>
              <v-col v-if="create && dropdowns.length > 0" class="shrink">
                <v-divider vertical></v-divider>
              </v-col>
              <v-col
                v-for="v in dropdownsRow1"
                :key="v.name"
                :class="{'col-12 col-sm-6 col-md-3 col-lg-2':dropdowns.length > 4}"
              >
                <v-autocomplete
                  dense
                  v-if="v.type == undefined || v.type == 'dropdown'"
                  outlined
                  :label="v.name"
                  :items="v.items"
                  v-model="v.selected"
                  @change="onChange"
                  :clearable="!v.notClearable"
                  hide-details
                ></v-autocomplete>
                <v-text-field
                  dense
                  v-if="v.type == 'text'"
                  outlined
                  :label="v.name"
                  v-model="v.selected"
                  @change="onChange"
                  clearable
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col class="shrink text-center" v-if="!hideSearchBtn && !moreFilters">
                <v-btn type="submit" color="primary">
                  <span>
                    <v-icon left>{{submitBtnTxt}}</v-icon>
                    {{submitBtnTxt}}
                  </span>
                </v-btn>
              </v-col>
              <v-col class="shrink text-center" v-if="moreFiltersBtn2">
                <v-btn text color="primary" @click="moreFilters = !moreFilters">
                  <v-icon left v-html="'keyboard_arrow_' + (moreFilters?'up':'down')"></v-icon>
                  {{moreFilters? 'hide filters':'more filters'}}({{dropdownsRow2.length}})
                </v-btn>
              </v-col>
            </v-row>
            <v-expand-transition>
              <v-row v-show="moreFilters" justify="start">
                <v-col
                  v-for="v in dropdownsRow2"
                  :key="v.name"
                  class="col-12 col-sm-6 col-md-3 col-lg-2"
                >
                  <v-autocomplete
                    dense
                    v-if="v.type == undefined || v.type == 'dropdown'"
                    outlined
                    :label="v.name"
                    :items="v.items"
                    v-model="v.selected"
                    @change="onChange"
                    :clearable="!v.notClearable"
                    hide-details
                  ></v-autocomplete>
                  <v-text-field
                    dense
                    v-if="v.type == 'text'"
                    outlined
                    :label="v.name"
                    v-model="v.selected"
                    @change="onChange"
                    clearable
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="shrink" v-if="!hideSearchBtn && moreFilters">
                  <v-btn type="submit" color="primary">
                    <span>
                      <v-icon left>{{submitBtnTxt}}</v-icon>
                      {{submitBtnTxt}}
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-expand-transition>
          </v-form>
        </div>
        <div class="ma-0 pa-0" v-if="!hideFiltersInfo">
          <AFilterInfo
            :filters="filtersDetails"
            :alwaysShow="awlaysShowFilterInfo == undefined? false : awlaysShowFilterInfo"
            @clear="clear"
          ></AFilterInfo>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>


<script>
import loadDropdown from "../mixins/loadDropdown";
import AFilterInfo from "../components/AFilterInfo";

function getValueByIdFromDropdownItems(items, id) { 
  console.log(items[0])
  for (let i = 0; i <items.length; i++) {
    const e = items[i];
    console.log(  e)
    console.log(`${e.value.id} == ${id}`)
    if (e.value.id == id)
      return e.value
  }
  return undefined
}

export default {
  name: "ASearchForm",
  mixins: [loadDropdown],
  components: {
    AFilterInfo
  },
  props: [
    "hideSearchBtn",
    "expandable",
    "filters",
    "modelName",
    "create",
    "dropdownProps",
    "awlaysShowFilterInfo",
    "hideFiltersInfo",
    "defaults"
  ],
  data() {
    return {
      showForm: true,
      moreFilters: false,
      dropdowns: [],
      filtersDetails: {}
    };
  },
  computed: {
    filtersPresent: function() {
      return this.filtersDetails && Object.keys(this.filtersDetails).length > 0;
    },
    submitBtnTxt: function() {
      return this.filtersPresent ? "search" : "refresh";
    },
    row1TargetFiltersCount: function() {
      if (
        this.create &&
        !this.hideSearchBtn &&
        !this.moreFilters &&
        this.dropdowns.length > 5
      )
        return 3;
      if (
        this.create &&
        !this.hideSearchBtn &&
        this.moreFilters &&
        this.dropdowns.length > 5
      )
        return 4;
      if (!this.hideSearchBtn && this.dropdowns.length > 5 && !this.moreFilters)
        if (
          !this.hideSearchBtn &&
          this.dropdowns.length > 5 &&
          !this.moreFilters
        )
          return 4;
      if (!this.hideSearchBtn && this.dropdowns.length > 5 && this.moreFilters)
        return 5;
      if (this.hideSearchBtn && this.dropdowns.length > 6) return 5;
      return 6;
    },
    moreFiltersBtn2: function() {
      return this.dropdowns.length > this.row1TargetFiltersCount;
    },
    dropdownsRow1: function() {
      let targetLength = this.moreFiltersBtn2
        ? this.row1TargetFiltersCount
        : this.dropdowns.length;
      return this.spliceDropdowns(0, targetLength);
    },
    dropdownsRow2: function() {
      return this.spliceDropdowns(
        this.row1TargetFiltersCount,
        this.dropdowns.length
      );
    }
  },
  mounted: function() {
    if (this.expandable) this.showForm = false;
    this.dropdownProps.forEach(el => {
      this.dropdowns.push({
        type: el.type,
        name: el.name,
        model: el.model,
        notClearable: el.notClearable,
        payloadKey: el.payloadKey,
        morePayloadKeys: el.morePayloadKeys,
        items: el.items || [],
        selected: undefined
      });
    });
    this.dropdowns.forEach(el => {
      if (el.model != undefined) {
        this.loadDropdownItems2(el.model, el.items, this.setDefaults);
      }
      if (el.type == "dropdown") {
        let arr = [];
        el.items.forEach(item => {
          arr.push({
            text: item.text,
            value: { name: item.text, id: item.value }
          });
        });
        el.items = arr;
      }
    });
  },
  methods: {
    onChange() {
      this.setFiltersDetails();
      this.$emit("change", this.payload());
    },
    spliceDropdowns(from = 0, to = 0) {
      let dropdowns = [];
      for (let i = from; i < to; i++) {
        dropdowns.push(this.dropdowns[i]);
      }
      return dropdowns;
    },
    setInputFromDefaults() {
      let input = this.defaults;
      let updated = false;
      if (!input) return
      this.dropdowns.forEach(el => {
        if(!input[el.payloadKey]) return
          switch(el.type) {
            case undefined:
            case "dropdown":
              el.selected = getValueByIdFromDropdownItems(el.items, input[el.payloadKey])
              updated = true;
          }
      })
      if (updated) this.onChange();
    },
    extractInputs(payload) {
      var p = {};
      this.dropdowns.forEach(el => {
        if (!!el.selected) {
          switch (el.type) {
            case undefined:
            case "dropdown":
              if (payload) {
                p[el.payloadKey] = el.selected.id;
                if (el.morePayloadKeys && el.morePayloadKeys.length > 0) {
                  el.morePayloadKeys.forEach(e => {
                    p[e] = el.selected.id;
                  });
                }
              } else
                p[el.name] = {
                  value: el.selected.name,
                  ob: el
                };
              break;
            case "text":
              if (payload) {
                p[el.payloadKey] = el.selected;
                if (el.morePayloadKeys && el.morePayloadKeys.length > 0) {
                  el.morePayloadKeys.forEach(e => {
                    p[e] = el.selected;
                  });
                }
              } else p[el.name] = { value: el.selected, ob: el };
              break;
          }
        }
      });
      return p;
    },
    payload() {
      return this.extractInputs(true);
    },
    setFiltersDetails: function() {
      this.filtersDetails = this.extractInputs(false);
    },
    clear() {
      this.dropdowns.forEach(el => {
        if (!el.notClearable) {
          el.selected = undefined;
        }
      });
      this.filtersDetails = {};
      this.onChange();
    },
    setDefaults() {
      this.setInputFromDefaults();
      this.dropdowns.forEach(el => {
        if (
          el.notClearable &&
          el.selected === undefined &&
          el.type == undefined
        ) {
          el.selected = el.items.length > 0 ? el.items[0].value : undefined;
          this.onChange();
        }
      });
    }
  }
};
</script>


<style>
</style>

